import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fetches editorial content (clubs, timeshares, blog posts) from the backend.
export function useContent(path, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setNotFound(false);
    axios
      .get(`${API}${path}`)
      .then((res) => {
        if (!active) return;
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        if (!active) return;
        setNotFound(err?.response?.status === 404);
        setLoading(false);
      });
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, notFound };
}
